import { useStore } from 'zustand';
import { useUserStore } from '../../../../stores/UserStore';
import { TtsModeEnum } from '../../../../types/tts/TtsType';

export const useShouldEnableVoicesMenu = () => {
  const userProfile = useStore(useUserStore, (state) => state.userProfile!);
  return userProfile.tts.enabled && userProfile.tts.ttsMode === TtsModeEnum.AZURE;
};
